import MatchDetailsEnded from "./MatchDetailsEnded.jsx";
import MatchDetailsStarted from "./MatchDetailsStarted.jsx";

export default function MatchDetailsStatus({ groupId, match, bet, hasMatchEnded }) {

  const getStatusComponent = (hasMatchEnded) => {
    if (hasMatchEnded) {
      return (
        <MatchDetailsEnded groupId={groupId} match={match} bet={bet} />
      );
    } else {
      return (
        <MatchDetailsStarted groupId={groupId} match={match} bet={bet} />
      );
    }
  }

  return (
    <>
      {getStatusComponent(hasMatchEnded)}
    </>
  );
}
